<div class="env" *ngIf="envName">{{ envName }}</div>
<div class="no-select">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
